import { Subject } from 'rxjs';

import type { RegularCall } from 'features/rns/interfaces';

export class RegularCallEventBus {
  static $newCall = new Subject<RegularCall>();
}
